import React from 'react';

/* ── Member-area footer (trading variant) ─────────────────────────────
 * Mirrors the public-site footer (nav links + risk disclaimer + bottom bar)
 * but self-contained: inline styles + absolute links to the public host, so
 * it needs neither react-router context nor the .tps-scope CSS bundle. */

const NAV = [
  { label: 'Головна',    path: '/'           },
  { label: 'Доходність', path: '/returns'    },
  { label: 'Гарантії',   path: '/guarantees' },
  { label: 'Ціни',       path: '/pricing'    },
  { label: 'Контакти',   path: '/contacts'   },
];

const LEGAL = ['Політика конфіденційності', 'Умови використання', 'Cookies'];

function publicUrl(path) {
  if (typeof window === 'undefined') return path;
  const { protocol, host } = window.location;
  return `${protocol}//${host.replace(/^app\./, '')}${path}`;
}

export default function CabinetFooter() {
  return (
    <footer style={{
      background: '#101220', color: '#fff', marginTop: 40,
      fontFamily: "'Inter','Segoe UI',system-ui,sans-serif",
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px 24px' }}>

        {/* nav */}
        <nav style={{ display: 'flex', gap: 28, flexWrap: 'wrap', marginBottom: 28 }} aria-label="Навігація у футері">
          {NAV.map(l => (
            <a
              key={l.label}
              href={publicUrl(l.path)}
              style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, fontWeight: 500, textDecoration: 'none' }}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* brand + disclaimer */}
        <div style={{
          display: 'flex', gap: 32, flexWrap: 'wrap',
          paddingBottom: 24, borderBottom: '1px solid rgba(255,255,255,0.12)',
        }}>
          <div style={{ flex: '1 1 220px', minWidth: 200 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 2, marginBottom: 10 }}>
              <span style={{ fontWeight: 700, fontSize: 20, letterSpacing: '-0.3px' }}>TRADING</span>
              <span style={{ color: 'rgb(177,196,247)', fontWeight: 700, fontSize: 13 }}>.com.ua</span>
            </div>
            <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: 'rgba(255,255,255,0.6)' }}>
              Автоматизована торгівля на фондовому ринку США через рахунок IBKR
            </p>
          </div>
          <div style={{ flex: '2 1 380px', minWidth: 260 }}>
            <h3 style={{ margin: '0 0 8px', fontSize: 14, fontWeight: 600 }}>Попередження про ризики</h3>
            <p style={{ margin: 0, fontSize: 12.5, lineHeight: 1.55, color: 'rgba(255,255,255,0.6)' }}>
              Торгівля на фондовому ринку пов&apos;язана з певним рівнем ризику. Минулі результати
              алгоритму не є 100%-ою гарантією майбутніх прибутків. Дохідність 45+% є цільовим
              показником стратегії, проте фактичний результат залежить від ринкової
              кон&apos;юнктури. Interactive Brokers LLC є незалежним брокером і не несе
              відповідальності за роботу нашого алгоритму
            </p>
          </div>
        </div>

        {/* bottom bar */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 12, paddingTop: 18,
        }}>
          <span style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.5)' }}>
            © 2026 Trading.com.ua. Всі права захищені
          </span>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            {LEGAL.map(l => (
              <a key={l} href={publicUrl('/')} style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
